import { render, staticRenderFns } from "./ScanRecord.vue?vue&type=template&id=70e6563a&scoped=true&"
import script from "./ScanRecord.vue?vue&type=script&lang=js&"
export * from "./ScanRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e6563a",
  null
  
)

export default component.exports